import Vue from "vue";
import Vuex from "vuex";

import application from "./application";
import pageParams from "./page-params";
import ui from "./ui";
import opener from "./opener";
import auth from "./auth";
import users from "./users";
import privacyPolicy from "./privacy-policy";
import termsOfUse from "./terms-of-use";
import contacts from "./contacts";
import groups from "./groups";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    application,
    pageParams,
    ui,
    opener,
    auth,
    users,
    privacyPolicy,
    termsOfUse,
    contacts,
    groups
  }
});

export default store;
